import NextLink from "next/link"
import styles from "../Button/Button.module.scss"
import cx from "classnames"
import { ArrowLeft, ArrowRight } from "react-feather"

const Link = (props) => {
  if (!props?.link || !props?.link?.link) return null

  const {
    link,
    label,
    new_tab: newTab,
    display_type: displayType,
    icon_position: iconPosition,
  } = props.link

  const { inverted, className } = props

  return (
    <NextLink href={link} passHref>
      <a
        target={newTab ? "_blank" : ""}
        className={cx(
          styles.Button,
          {
            [styles.primary]:
              displayType?.value === "button_primary" && !inverted,
            [styles.primaryInverted]:
              displayType?.value === "button_primary" && inverted,
            [styles.secondary]: displayType?.value === "button_secondary",
            [styles.tertiary]: displayType?.value === "button_tertiary",
            [styles.link]: displayType?.value === "link",
            [styles.noPadding]: !label,
          },
          className
        )}
      >
        {iconPosition?.value === "left" && <ArrowLeft className="h-6 w-6" />}
        {label && (
          <span
            className={cx({
              "ml-4": iconPosition?.value === "left",
              "mr-4": iconPosition?.value === "right",
            })}
          >
            {label}
          </span>
        )}
        {iconPosition?.value === "right" && <ArrowRight className="h-6 w-6" />}
      </a>
    </NextLink>
  )
}

export default Link
